import React from 'react';
import type { CSSProperties } from 'react';
import { INK } from '../styles';

interface Props {
  children: React.ReactNode;
  style?: CSSProperties;
}

export default function Box({ children, style }: Props) {
  return (
    <div style={{
      border: '1px solid ' + INK,
      padding: '8px 10px',
      flex: 1,
      ...(style || {}),
    }}>
      {children}
    </div>
  );
}